import cnt from "../../services/definedConstant";
import definedApi from "../../services/definedApi";
import { BOM } from "../../services/definedMethod";
import appLabel from "../../config/appLabel";
import { useNavigate } from "react-router-dom";

export const getGlListAction = (
  body,
  setGlList,
  setOriginalList,
  setLoading
) => {
  // let body = {
  //   session,
  // };

  return async (dispatch) => {
    BOM.FetchReqAction(body, definedApi.GlAccount, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            account: element?.name ? element?.name : "No description",
            glCode: element?.glCode ? element?.glCode : "No Code",
            accountType: element?.type?.value,
            disabled: element?.disabled,
            manualEntriesAllowed: element?.manualEntriesAllowed,
            usedAs: element?.usage?.value,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setGlList(tempArray.filter((item) => item.disabled === false));

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setLoading(false);
      }
    });
  };
};

export const newGlAccountAction = (body, setIsLoading) => {
  setIsLoading(true);
  return async (dispatch) => {
    BOM.FetchReqAction(body, definedApi.NewGlAccount, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        console.log(err);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, appLabel.newGLCreatedMsg);
        useNavigate()("/gla0100");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
};

export const getGlDetailAction = (body, setGlDetail, setLoading) => {
  return async (dispatch) => {
    BOM.FetchReqAction(body, definedApi.GlAccount, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objDetail = res;

        //STOP LOAD
        setLoading(false);
      }
    });
  };
};
